export default __webpack_public_path__ + "static/media/imprint.98e7b253.md";